import script from "./FooterLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLinks.vue?vue&type=script&setup=true&lang=js"

import "./FooterLinks.vue?vue&type=style&index=0&id=3e86bf1e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e86bf1e"]])

export default __exports__